import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'app-application-form',
    templateUrl: './application-form.component.html',
    imports: [
        NgIf
    ]
})
export class ApplicationFormComponent implements OnInit {
    // pageHeading = "";
    model = {
        submitted: false
    }

    ngOnInit(): void {
        console.log('application form initial load...');

        Breakpoint.init();
    }
}
